import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';

const Tasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await api.get('/api/tasks');
      setTasks(res.data);
    } catch (err) {
      setError('Could not load tasks.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addTask = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    try {
      await api.post('/api/tasks', { title, notes: notes.trim() || undefined });
      setTitle('');
      setNotes('');
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Could not add task.');
    }
  };

  const toggle = async (id) => {
    setTasks(ts => ts.map(t => t.id === id ? { ...t, completed: !t.completed } : t));
    try {
      await api.patch(`/api/tasks/${id}/toggle`);
      load();
    } catch (err) {
      load();
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this task?')) return;
    await api.delete(`/api/tasks/${id}`);
    load();
  };

  const open = tasks.filter(t => !t.completed);
  const doneToday = tasks.filter(t => t.completed);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Tasks</h1>
        <p className="page-subtitle">Shared list for the directors. Anything unticked carries over to tomorrow and lands in the 7am email.</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="card" style={{ marginBottom: 24 }}>
        <div className="card-body">
          <form onSubmit={addTask} style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <input
              className="form-control"
              style={{ flex: '2 1 220px' }}
              placeholder="What needs doing?"
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
            <input
              className="form-control"
              style={{ flex: '2 1 180px' }}
              placeholder="Notes (optional)"
              value={notes}
              onChange={e => setNotes(e.target.value)}
            />
            <button type="submit" className="btn btn-gold" style={{ flex: '0 0 auto' }}>Add Task</button>
          </form>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 24 }}>
        <div className="card-header"><h2 className="card-title">To Do ({open.length})</h2></div>
        <div className="card-body">
          {loading ? <div className="loader" /> : open.length === 0 ? (
            <div className="empty-state">Nothing outstanding. Enjoy it while it lasts.</div>
          ) : open.map(t => (
            <div key={t.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, padding: '12px 4px', borderBottom: '1px solid var(--border)' }}>
              <input
                type="checkbox"
                checked={false}
                onChange={() => toggle(t.id)}
                style={{ width: 20, height: 20, marginTop: 2, accentColor: 'var(--gold)', cursor: 'pointer' }}
              />
              <div style={{ flex: 1 }}>
                <div style={{ color: 'var(--navy)', fontSize: 15 }}>
                  {t.title}
                  {t.carried_over && <span className="badge badge-pending" style={{ marginLeft: 10 }}>Carried over</span>}
                </div>
                {t.notes && <div style={{ color: 'var(--grey-mid)', fontSize: 13, marginTop: 2 }}>{t.notes}</div>}
                <div style={{ color: '#a9a9a9', fontSize: 11, marginTop: 4 }}>
                  Added by {t.created_by_name || 'unknown'}
                </div>
              </div>
              <button className="btn btn-outline btn-sm" onClick={() => remove(t.id)}>Delete</button>
            </div>
          ))}
        </div>
      </div>

      {doneToday.length > 0 && (
        <div className="card">
          <div className="card-header"><h2 className="card-title">Done Today ({doneToday.length})</h2></div>
          <div className="card-body">
            {doneToday.map(t => (
              <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '10px 4px', borderBottom: '1px solid var(--border)' }}>
                <input
                  type="checkbox"
                  checked
                  onChange={() => toggle(t.id)}
                  style={{ width: 20, height: 20, accentColor: 'var(--gold)', cursor: 'pointer' }}
                />
                <div style={{ flex: 1, color: 'var(--grey-mid)', fontSize: 14, textDecoration: 'line-through' }}>
                  {t.title}
                </div>
                <div style={{ color: '#a9a9a9', fontSize: 11 }}>
                  {t.completed_by_name || ''}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tasks;
